// extracted by mini-css-extract-plugin
module.exports = {"metric":"UnJGN","grid":"ODq7A","metricLabel":"_33-wm","list":"Q8F8a","emphasis":"YsBXj","metricLabelWrapper":"_2_mF3","metricValue":"_3apuw","noMargin":"_EivO"};